/* eslint-disable no-shadow */
export const getDefaultState = () => ({
  mode: 'basic',
});

export const state = getDefaultState();

export const types = {
  RESET: 'RESET',
  SETMODE: 'SETMODE',
};

export const mutations = {
  [types.RESET](state) {
    Object.assign(state, getDefaultState());
  },

  [types.SETMODE](state, value) {
    state.mode = value;
  },
};

export const getters = {
  isCustomerMode: (state, getters, rootState, rootGetters) => !rootGetters['system/hasShowCCTransactionView'] || state.mode === 'customer',
  isBasicMode: (state, getters, rootState, rootGetters) => rootGetters['system/hasShowCCTransactionView'] && state.mode === 'basic',
  isExpertMode: (state, getters, rootState, rootGetters) => rootGetters['system/hasShowCCTransactionView'] && state.mode === 'expert',
};

export const actions = {
  setMode({ commit }, value) {
    commit(types.SETMODE, value);
  },

  setBasicMode({ commit }) {
    commit(types.SETMODE, 'basicMode');
  },
};
